import { categoryList } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="kategorie" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full mb-4">
            Kategorie Produktów
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Przeglądaj <span className="text-primary-500 italic">Kakobuy Finds</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            Wybierz kategorię i przejdź do pełnej listy produktów w arkuszu Kakobuy Spreadsheet
          </p>
        </div>

        <div className="relative">
          <div className="flex overflow-x-auto gap-4 pb-4 snap-x snap-mandatory" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
            {categoryList.map((cat) => (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex-shrink-0 w-[200px] md:w-[220px] snap-start group cursor-pointer"
              >
                <div className="bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-300 group-hover:-translate-y-1">
                  <div className="relative w-full h-[160px] md:h-[180px] overflow-hidden">
                    <img
                      src={cat.imageUrl}
                      alt={`${cat.namePl} – Kakobuy Spreadsheet`}
                      title={`${cat.namePl} – Kakobuy Finds`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-3 md:p-4">
                    <span className="text-xs text-accent-600 font-medium bg-accent-50 px-2 py-0.5 rounded-full">
                      Kakobuy
                    </span>
                    <p className="text-sm md:text-base font-semibold text-foreground-900 mt-2 whitespace-nowrap">
                      {cat.namePl}
                    </p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}